import React from 'react'
import compareSize from '../helpers/compareSize'
import compareColor from '../helpers/compareColor'
import ModalDetailStaticsItem from './ModalDetailStaticsItem'

class ListItemsOverview extends React.Component {
    state = {
        isOpen: false
    }

    _calculateItems = (items) => {
        const total = []

        for (const item of items) {
            let { products } = item

            if (item.hasOwnProperty('filteredProducts')) {
                products = item.filteredProducts
            }

            for (const product of products) {
                const color = typeof product.color === 'string' ? product.color.toUpperCase().trim() : ''
                const size = typeof product.size === 'string' ? product.size.toUpperCase().trim() : ''
                const find = total.find(totalItem => totalItem.color === color && totalItem.size === size)

                if (find) {
                    find.sum += 1
                } else {
                    total.push({ color, size, sum: 1 })
                }
            }
        }

        return total
    }

    _getSum = (total, color, size) => {
        const item = total.find(totalItem => totalItem.color === color.toUpperCase() && totalItem.size === size.toUpperCase())
        if (item) return item.sum || 0
        return 0
    }

    _getSumKey = (total, key, value) => {
        const filteredItems = total.filter(item => item[key].toUpperCase() === value.toUpperCase())
        return filteredItems.reduce((sum, item) => sum + item.sum, 0)
    }

    _getColors = (total) => {
        const colors = []
        for (let item of total) {
            const color = item.color.toUpperCase()
            if (!colors.includes(color)) colors.push(color)
        }
        return colors
    }

    _getSizes = (total) => {
        const sizes = []
        for (let item of total) {
            const size = item.size.toUpperCase()
            if (!sizes.includes(size)) sizes.push(size)
        }
        return sizes
    }

    _getTotalSum = (total) => {
        return total.reduce((sum, item) => sum + item.sum, 0)
    }

    _handleOpen = () => {
        this.setState({ isOpen: true })
    }

    _handleClose = () => {
        this.setState({ isOpen: false })
    }

    render() {
        const { isOpen } = this.state
        const { items, filter, history } = this.props
        const total = this._calculateItems(items)
        const colors = this._getColors(total).sort(compareColor)
        const sizes = this._getSizes(total).sort(compareSize)
        const totalSum = this._getTotalSum(total)
        const { location } = Object.assign({}, history)
        const queryParams = new URLSearchParams(location.search)
        const params = Object.fromEntries(queryParams.entries())

        return (
            <div className='table-responsive'>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Color</th>
                            {
                                sizes.map(size => {
                                    return <th key={size}>{size}</th>
                                })
                            }
                            <th className='d-flex flex-column'>
                                Total: {totalSum}
                                {
                                    Object.keys(params).length > 0 &&
                                    <span
                                        className='cursor-pointer text-primary'
                                        onClick={this._handleOpen}
                                    >Show details</span>
                                }
                                {
                                    isOpen &&
                                    <ModalDetailStaticsItem
                                        isOpen={isOpen}
                                        onClose={this._handleClose}
                                        filter={filter}
                                        params={params}
                                    />
                                }
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            colors.map(item => {
                                return <tr key={item}>
                                    <td>{item}</td>
                                    {
                                        sizes.map(size => {
                                            return <td key={size}>{this._getSum(total, item, size)}</td>
                                        })
                                    }
                                    <td>{this._getSumKey(total, 'color', item)}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

export default ListItemsOverview
